import { makeVar } from '@apollo/client';
const isEditModeInitialValue = false;
export const isEditModeVar = makeVar<boolean>(isEditModeInitialValue);
